module.exports = __webpack_public_path__ + "static/media/5.e0b4dee2.jpg";